import axios from 'src/utils/axios'

import { ManagementRegistrationFormData } from 'src/types/management/form'
import { Company } from 'src/types/management'

export const create = async (formData: ManagementRegistrationFormData): Promise<Company> => {
  const { data } = await axios.post(`/management/companies`, formData)

  return data
}
